import { IsBoolean, IsInt, IsOptional, IsString, Min } from 'class-validator';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { jsonStringToObject } from '../../types-transformers';
import { EventBundleWithStatsDto } from '../dto/event-bundle.dto';
import { Transform, Type } from 'class-transformer';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { UserToEventBundleDto } from '../dto/user-to-event-bundle.dto';

export class EventBundleOrdersDashboardFilter implements OrderFilter<UserToEventBundleDto>, PaginationFilter {
  @Transform(jsonStringToObject)
	@IsOptional()
	public orderedBy?: OrderParamPair<UserToEventBundleDto>[] | null;

	@IsOptional()
	@IsString()
	public search?: string;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public pageSize?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public page?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(0)
	public offset?: number | null;

}

export class EventBundleFilter implements OrderFilter<EventBundleWithStatsDto>, PaginationFilter {
  @Transform(jsonStringToObject)
	@IsOptional()
	public orderedBy?: OrderParamPair<EventBundleWithStatsDto>[] | null;

	@IsOptional()
	@IsString()
	public search?: string;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public pageSize?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public page?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(0)
	public offset?: number | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withDrafts?: boolean | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withWaitingForApproval?: boolean | null;
}

export class UserEventBundleFilter {
	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withUser?: boolean | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withEventBundle?: boolean | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withEventOrders?: boolean | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public withBundleOrder?: boolean | null;

	@IsOptional()
	@Type(() => Boolean)
	@IsBoolean()
	public active?: boolean | null;
}
